module.exports = __webpack_public_path__ + "static/img/happy_new_year.9919544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gift/specific/happy_new_year.png
// module id = xzmf
// module chunks = 1